




















import { Icon, Button } from '@alpha/ink'
import { Component, Vue, Prop } from 'vue-property-decorator'

import analytics from '@/analytics'

export interface Window {
  [key:string]: any; // Add index signature
}

@Component({
  components: {
    Icon,
    Button
  }
})
export default class CTADownload extends Vue {
  @Prop({ required: true }) referenceId!:string
  @Prop({ required: true }) exportEagleUrl!:string

  showBubble:boolean = false
  window:Window = window

  get pdfDownloadURL ():string {
    return `${this.exportEagleUrl}/reports/${this.referenceId}/export/pdf`
  }

  get docxDownloadURL ():string {
    return `${this.exportEagleUrl}/reports/${this.referenceId}/export/docx`
  }

  trackAnalyticsAndExport (format: string) {
    analytics.track('Shared Report Exported', {
      format: format
    })
  }
}
